module.exports = __webpack_public_path__ + "img/chevron-orange.9454dece.svg";